import React from 'react'
import { useNavigate } from 'react-router-dom'

const Category = ({ name, id, parent, remove, category }) => {
    const navigate = useNavigate()
    return (
        <div className='contact mb-3 user-card'>
            <div>
                <p>{id}</p>
            </div>
            <div className='res'>
                <p>{name}</p>
            </div>
            <div className='res'>
                <p>{parent ? parent.name : <span style={{ color: "red" }}>دسته اصلی</span>}</p>
            </div>
            <div>
                <button onClick={() => { remove(id) }}>حذف</button>
                <button onClick={() => navigate('/panel/admin/editCategory', { state: category })} style={{ backgroundColor: "#6083FF", marginTop: "10px", marginRight: "5px" }}>ویرایش</button>
            </div>
        </div>
    )
}

export default Category